export default __webpack_public_path__ + "static/banner-real-stories-saving-spending-lending-maddy-a4fab4c2086f2da177aaf4d249d7d5b9.jpg";